module.exports = __webpack_public_path__ + "static/media/chorthippus_brunneus_002_APA.dab43c96.png";